import React from "react";


function Box3(){
    return(
        <div>
            <div className="box3"> </div>
        </div>
    )
}

export default Box3;